import { defineComponent, ref, computed, watch } from "vue";
import SvgIcon from "./SvgIcon.vue.mjs";
import CloseIcon from "../icons/CloseIcon.vue.mjs";
import { addSuffix } from "../../../utils/utils.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Drawer",
  props: {
    title: { default: "" },
    value: { type: Boolean, default: false },
    modal: { type: Boolean, default: false },
    size: { default: "400" },
    beforeClose: { type: [Function, null], default: void 0 },
    appendToBody: { type: Boolean, default: false },
    appendToRoomContainer: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props, { emit }) {
    const props = __props;
    const drawerRef = ref();
    const visible = ref(false);
    const drawerContainerStyle = computed(() => `width: ${addSuffix(props.size)}`);
    watch(
      () => props.value,
      (val) => {
        visible.value = val;
      }
    );
    watch(visible, (val) => {
      var _a;
      if (val) {
        if (props.appendToBody) {
          document.body.appendChild(drawerRef.value);
        } else if (props.appendToRoomContainer) {
          (_a = document.getElementById("roomContainer")) == null ? void 0 : _a.appendChild(drawerRef.value);
        }
      }
    });
    function doClose() {
      visible.value = false;
      emit("input", false);
    }
    function handleClose() {
      if (props.beforeClose) {
        props.beforeClose(doClose);
      } else {
        doClose();
      }
    }
    let mouseDownInCurrentTarget = false;
    let mouseUpInCurrentTarget = false;
    function handleOverlayMouseUp(event) {
      mouseUpInCurrentTarget = event.target === event.currentTarget;
    }
    function handleOverlayMouseDown(event) {
      mouseDownInCurrentTarget = event.target === event.currentTarget;
    }
    function handleOverlayClick() {
      if (!props.closeOnClickModal) {
        return;
      }
      if (mouseDownInCurrentTarget && mouseUpInCurrentTarget) {
        handleClose();
        mouseDownInCurrentTarget = false;
        mouseUpInCurrentTarget = false;
      }
    }
    return { __sfc: true, props, emit, drawerRef, visible, drawerContainerStyle, doClose, handleClose, mouseDownInCurrentTarget, mouseUpInCurrentTarget, handleOverlayMouseUp, handleOverlayMouseDown, handleOverlayClick, SvgIcon, CloseIcon };
  }
});
export {
  _sfc_main as default
};
